import { render, staticRenderFns } from "./ShelfManageEdit.vue?vue&type=template&id=18ac1056&scoped=true"
import script from "./ShelfManageEdit.vue?vue&type=script&lang=js"
export * from "./ShelfManageEdit.vue?vue&type=script&lang=js"
import style0 from "./ShelfManageEdit.vue?vue&type=style&index=0&id=18ac1056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac1056",
  null
  
)

export default component.exports